module.exports = __webpack_public_path__ + "img/9788973817757.99f224b0.jpg";